export default {
  __default__: 'Something went wrong!!',
  LimitExceededException: 'Attempt limit exceeded, please try after some time.',
};
